import createUploadLink from 'apollo-upload-client/createUploadLink.mjs'

import { platformApiGraphqlUrl } from '@/config/env'

import { uploadFetch } from './uploadFetch'

export const platformApiHttpLink = createUploadLink({
  credentials: 'include',
  uri: platformApiGraphqlUrl,
  fetch: uploadFetch,
})
